export default "__VITE_ASSET__bAexDhTn__"